<template>
    <div class="content-box">
         <div class="content">
             <div class="title-box">
                 <div class="title">
                     <div class="title-text">优质服务</div>
                     <div class="title-e">QUALITY SERVICE</div>
                     <div class="title-line"></div>
                 </div>
                 <div class="end-rukou">
                 </div>
             </div>
             <div class="describe" style="height: auto">
               极能充五星级充电站全站标配120KW直流快充充电桩，为客户提供快速能源补给服务，配备休息室、卫生间、停车场等服务设施，提供餐饮、购物、汽车维修、包月充电、包月挪车等多种增值服务业务。针对企业客户，提供充值返利、消费返利、协议电价等多种合作模式，确保客户利益最大化。
             </div>
             <div class="describe-row">
                 <div class="row-item">
                     <span class="icon-img icon2"></span> 各项优惠福利
                 </div>
             </div>
             <div class="describe-row">
                 <div class="row-item">
                     <span class="icon-img icon1"></span> 配套服务完善
                 </div>
             </div>

             <div class="describe-characteristic left50">
                 <div>
                     <div class="icon-img icon3">
                         <span>休息区</span>
                     </div>
                     <div class="icon-img icon4">
                         <span>便利店</span>
                     </div>
                     <div class="icon-img icon5">
                         <span>卫生间</span>
                     </div>
                     <div class="icon-img icon6">
                         <span>WI-FI</span>
                     </div>
                 </div>
             </div>
             <div class="img-describe img"></div>
         </div>
    </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  methods: {},
}
</script>
<style src="./k_public.less" lang="less" scoped></style>